import * as tslib_1 from "tslib";
import { Data } from '../../data';
var CollectionField = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionField, _super);
    function CollectionField(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        var keys = 'dataField,displayTemplate';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
        return _this;
    }
    CollectionField.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), {
            "type": "CollectionField",
            "dataField": this.dataField,
            "displayTemplate": this.displayTemplate
        });
    };
    CollectionField.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return CollectionField;
}(Data));
export { CollectionField };
//# sourceMappingURL=collection_field.js.map